export default {
  id: null,
  nome: null,
  plataforma: null,
  servico: null,
  situacao: null,
  dataEnvio: null,
  campanhaModeloId: null,
  campanhaListaId: null,
  observacao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/campaign/campaignmodel.js